document.addEventListener("sections:loaded", () => {
  document.querySelectorAll("[data-product-recommendations]").forEach(async (section) => {
    const url = section.dataset.url;
    if (!url) {
      return;
    }

    try {
      const response = await fetch(url);
      if (!response.ok) {
        return;
      }

      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, "text/html");
      const recommendations = doc.querySelector("[data-product-recommendations]");

      if (recommendations && recommendations.innerHTML.trim().length > 0) {
        section.innerHTML = recommendations.innerHTML;
        section.dispatchEvent(new CustomEvent("product-recommendations:loaded", { bubbles: true }));
      }
    } catch (error) {
      console.error(error);
    }
  });
});
